<template>
  <select class="chzn-select2" ref="innerSelect" :multiple="multiple" v-on="listeners" data-allow-clear="false" :disabled="disabled">
    <option v-if="!not_blank" value></option>
    <option
      v-for="(opt, index) in optionsList"
      :key="index"
      :value="opt[1]"
      :selected="selectedOpt(opt)"
      :disabled="(opt[2] && opt[2]['disabled'] == true) || (typeof opt[2] == 'string' && opt[2] == 'disabled')"
    >
      {{ labelFunc ? labelFunc(opt[0]) : opt[0] }}
    </option>
  </select>
</template>
<script>
export default {
  name: 'vSelect2',
  props: {
    idAttr: null,
    element_id: null,
    element_description: null,
    element_data: null,
    optionsList: { type: Array },
    value: {},
    not_blank: { type: Boolean, default: false },
    multiple: { type: Boolean },
    labelFunc: { type: Function },
    selectConfig: null,
    withCredentials: { type: Boolean, default: false },
    disabled: { type: Boolean },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: (event) => this.$emit('input', event.target.value),
      };
    },
  },
  methods: {
    selectedOpt(opt) {
      return this.multiple && Array.isArray(this.value)
        ? this.value.find((el) => (this.idAttr && el[this.idAttr] ? el[this.idAttr] : el) == opt[1])
        : this.value == opt[1];
    },
    manualSetup(innerSelect) {
      innerSelect.select2({
        placeholder: this.selectConfig.placeholder || window.i18nJS.clic_per_selezionare,
        theme: 'bootstrap',
        ajax: {
          url: this.selectConfig.url,
          xhrFields: { withCredentials: this.withCredentials },
          headers: this.selectConfig.headers,
          delay: 500,
          data: function (params) {
            const query = {
              term: params.term,
              page: params.page || 1,
            };
            // Query parameters will be ?search=[term]&page=[page]
            return query;
          },
          processResults: this.selectConfig.processResults,
          contentType: 'application/json; charset=utf-8',
        },
      });
    },
    initSelect(innerSelect) {
      if (this.selectConfig) {
        this.manualSetup(innerSelect);
      } else {
        window.CreateSelect2.initEl(innerSelect);
      }
    },
  },
  mounted() {
    const innerSelect = $(this.$el);
    $(innerSelect).addClass(this.otherClass);
    this.initSelect(innerSelect);
    innerSelect.on('select2:clearing', (evt) => {
      if (this.multiple) {
        innerSelect.val([]);
      }
    });
    innerSelect.on('change', (evt) => {
      const rawValue = innerSelect.val();
      const thisValue =
        this.multiple && rawValue && this.optionsList
          ? rawValue.map((val) => this.optionsList.find((opt) => opt[1] == val)?.[1])
          : rawValue; // retrieves original value from optionList instead of getting them parsed from DOM
      this.$emit('update:element_id', thisValue);
      if (this.multiple) {
        this.$emit(
          'update:element_description',
          innerSelect.select2('data').map((v) => v.text),
        );
        this.$emit('update:element_data', innerSelect.select2('data'));
      } else {
        this.$emit('update:element_description', innerSelect.select2('data').map((v) => v.text)[0]);
        this.$emit('update:element_data', innerSelect.select2('data')[0]);
      }
      this.$emit('input', thisValue);
    });
    this.$emit('mounted', innerSelect);

    eventBus.$on('select2init', () => {
      if (this.selectConfig) {
        this.initSelect(innerSelect);
      }
    });
  },
  beforeDestroy() {
    $(this.$el).select2('destroy');
  },
};
</script>

<style lang="scss">
.chzn-select2 {
  &.input-fit + span.select2 {
    width: fit-content !important;

    ul.select2-selection__rendered {
      min-width: 206px;
      max-width: 350px;
    }
  }
}
</style>
